export default __webpack_public_path__ + "static/media/editIcon.c4cfaf33.svg";